import { ArrowUpRight } from "lucide-react"
import { memo, useCallback } from "react"
import type { UserMessage } from "./data/marquee-config"
import { marqueeConfig } from "./data/marquee-config"

interface MarqueeMessageProps {
  message: UserMessage
}

export const MarqueeMessage = memo(function MarqueeMessage({ message }: MarqueeMessageProps) {
  const { classes, truncateLength, twitterUrl } = marqueeConfig

  const handleClick = useCallback(() => {
    window.open(twitterUrl, "_blank")
  }, [twitterUrl])

  const truncatedMessage =
    message.message.length > truncateLength
      ? `${message.message.slice(0, message.message.lastIndexOf(" ", truncateLength))}…`
      : message.message

  return (
    <button
      type="button"
      className={classes.messageButton}
      onClick={handleClick}
      aria-label={`View @bracky's message: ${message.message}`}
    >
      {/* Avatar */}
      <img src={message.avatar} alt="" className={classes.avatar} />
      <span className={classes.brackyLabel}>@bracky</span>
      {/* Message - full on desktop, truncated on mobile */}
      <span className="mx-1.5">
        <span className="md:hidden">{truncatedMessage}</span>
        <span className="hidden md:inline">{message.message}</span>
      </span>
      {/* Timestamp */}
      <span className={classes.timestamp}>{message.timestamp}</span>
      <ArrowUpRight className={classes.arrow} />
    </button>
  )
})
